import {
  AdaptedCreditOffersResponse,
  ApiBnplCreditOffer,
  ApiCreditOffersAttributes,
  ApiCtaCreditOffer,
  ApiStcCreditOffer,
  ApiTake3CreditOffer,
  BnplCreditOffer,
  CtaCreditOffer,
  StcCreditOffer,
  Take3CreditOffer,
} from 'types/CreditOfferTypes';
import { adaptCreditOfferAttributes } from './attributes/attribute-adaptor';

const adaptCreditOffer = (offer: ApiStcCreditOffer | ApiTake3CreditOffer | ApiBnplCreditOffer | ApiCtaCreditOffer) => {
  const { type, primary } = offer;

  return <StcCreditOffer | Take3CreditOffer | BnplCreditOffer | CtaCreditOffer>{
    type: type.toLowerCase(),
    primary,
    attributes: adaptCreditOfferAttributes(offer),
  };
};

const adaptAprValue = (aprValue: number): string => `${aprValue}%`;

const adaptCreditOffers = (data: ApiCreditOffersAttributes): AdaptedCreditOffersResponse => {
  const adaptedCreditOffers = <AdaptedCreditOffersResponse>{
    apr: adaptAprValue(data.apr.value),
  };

  if (data.offers) {
    data.offers.forEach((offer) => {
      const { type, primary } = offer;
      const adaptedCreditOffer = adaptCreditOffer(offer);

      adaptedCreditOffers.offers = {
        ...adaptedCreditOffers.offers,
        [type.toLowerCase()]: adaptedCreditOffer,
      };

      if (primary) {
        adaptedCreditOffers.primary = adaptedCreditOffer;
      }
    });
  }

  return adaptedCreditOffers;
};

export default adaptCreditOffers;
